<template>
    <div class="modal_content p-t-0">
        <div class="row">
            <div class="col-xs-12 col-sm-6">
                <h5 class="m-t-10"><i class="fa-fw fa fa-toggle-right"></i> {{ $t('pipeline_steps') }}</h5>
            </div>
            <div class="col-xs-12 col-sm-6 m-b-15">
                <div :class="{ 'has-error': errors['name'] }" v-pml-block="isSaving">
                    <div class="input-group">
                        <input type="text" v-model="newStep" @keyup.enter="store" @keydown.tab.prevent="store" class="form-control" v-pml-focus :placeholder="$t('new_step')" maxlength="30">
                        <span class="input-group-btn">
                            <button class="btn btn-default btn-sm btn_input_group" @click="store" v-pml-tooltip="$t('add')"><i class="fa fa-plus-circle"></i></button>
                        </span>
                    </div>
                    <span class="error" v-if="errors['name']">{{ errors['name'][0] }}</span>
                </div>
            </div>
        </div>
        <vue-draggable class="pipeline pipeline_add" :list="record.steps" :options="dragOptions" @end="updateOrder">
            <PmlItem v-for="item in record.steps" :key="item.id" :item="item" @fetchPipeline="fetchPipeline"></PmlItem>
        </vue-draggable>
        <p v-if="!record.steps.length" class="t_center"><i class="fa fa-exclamation-triangle"></i> {{ $t('sign_the_pipeline_steps') }}</p>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import PmlItem from './StepItem.vue'
    import { trans } from 'utils/helpers/translation'
    import { create, sort } from 'services/pipeline-steps'
    import _ from 'lodash'

    export default {
        name: 'PipelineStepsForm',
        components: { PmlItem },
        props: [ 'record' ],
        data () {
            return {
                errors: [],
                isSaving: false,
                newStep: ''
            }
        },
        computed: {
            dragOptions () {
                return {
                    animation: 0,
                    ghostClass: 'ghost'
                }
            }
        },
        methods: {
            fetchPipeline (id) {
                this.$emit('fetchPipeline', id)
            },
            updateOrder () {
                sort(this.record.id, { items: _.map(this.record.steps, 'id') })
                    .then(() => {
                        this.fetchPipeline(this.record.id)
                    })
                    .catch(() => {
                        this.fetchPipeline(this.record.id)
                        Notify.error(trans('_notifications.error'))
                    })
                    .then(() => {
                        this.errors = []
                    })
            },
            store () {
                this.isSaving = true

                create(this.record.id, { name: this.newStep })
                    .then(() => {
                        this.fetchPipeline(this.record.id)
                        this.newStep = ''
                        this.errors = []
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/parameters/pipelines/components/Steps.vue